import { TripLegType } from '@/data/models/reservation.model';
import type { AnyActorRef } from 'xstate';

import {
  emptyReservationFormValues,
  type ReservationFormInput,
  type ReservationFormValues,
} from '../schema/reservationForm.schema';
import { getTripsFromMachines } from './getTripsFromMachines';

import type { ReservationFormMainContext } from '../machines/reservationFormMain.types';
import type { TripTypeContext } from '../machines/tripType.machine';

function readTripTypeField(ref: AnyActorRef | null): TripLegType {
  if (!ref) return TripLegType.OneWay;
  const ctx = ref.getSnapshot().context as TripTypeContext;
  return ctx.value;
}

export function getAggregatedFormValues(
  context: ReservationFormMainContext,
): ReservationFormValues {
  return {
    ...emptyReservationFormValues,
    tripType: readTripTypeField(context.tripTypeRef),
    trips: getTripsFromMachines(context),
  } as ReservationFormValues;
}

/** Merges machine-derived trips/tripType with live RHF top-level fields (phones, override, errors). */
export function mergeAggregatedWithLiveForm(
  context: ReservationFormMainContext,
  live: Partial<ReservationFormInput>,
): ReservationFormValues {
  const agg = getAggregatedFormValues(context);
  return {
    ...agg,
    genericErrors: live.genericErrors ?? agg.genericErrors,
    MemberHomePhone: live.MemberHomePhone ?? agg.MemberHomePhone,
    MemberMobilePhone: live.MemberMobilePhone ?? agg.MemberMobilePhone,
    ShowOtherInputs: live.ShowOtherInputs ?? agg.ShowOtherInputs,
    AlternateContact: live.AlternateContact ?? agg.AlternateContact,
    AlternateContactType: live.AlternateContactType ?? agg.AlternateContactType,
    AlternateContactFirstName:
      live.AlternateContactFirstName ?? agg.AlternateContactFirstName,
    AlternateContactLastName:
      live.AlternateContactLastName ?? agg.AlternateContactLastName,
    AlternateContactPhone: live.AlternateContactPhone ?? agg.AlternateContactPhone,
    AlternateContactAllowSMS:
      live.AlternateContactAllowSMS ?? agg.AlternateContactAllowSMS,
    AdditionalPassengers: live.AdditionalPassengers ?? agg.AdditionalPassengers,
    AdditionalPassengerCount:
      live.AdditionalPassengerCount ?? agg.AdditionalPassengerCount,
    AllowOverride: live.AllowOverride ?? agg.AllowOverride,
    OverrideFirstName: live.OverrideFirstName ?? agg.OverrideFirstName,
    OverrideLastName: live.OverrideLastName ?? agg.OverrideLastName,
    OverrideReason: live.OverrideReason ?? agg.OverrideReason,
    OverrideServicePlan: live.OverrideServicePlan ?? agg.OverrideServicePlan,
    trips: agg.trips.map((mt, i) => ({
      ...mt,
      ...(live.trips?.[i] ?? {}),
    })),
  } as ReservationFormValues;
}
